module.exports = __webpack_public_path__ + "static/explainer3-alt-8ab967728c617cd08b545b9ecb9ca31e.png";